export default {
    fontFamily: 'Karla',
    useNextVariants: true
};
